import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const getPaymentPlanElements = (
    token: string,
    backend: string,
    projectId?: string,
    offerId?: string,
    toDate?: string,
    fromDate?: string,
    filter?: string,
) => {
    return fetch(
        `${getApiUrl(backend)}payment_plan_elements?${projectId ? '&projectId=' + projectId : ''}${offerId ? '&offerId=' + offerId : ''}${fromDate ? '&fromDate=' + fromDate : ''}${toDate ? '&toDate=' + toDate : ''}${filter ? '&filter=' + filter : ''}`,
        {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );
};

export default getPaymentPlanElements